import { Carousel } from "antd";
import { FC, useEffect, useRef, useState } from "react";
import { FeatureNewsDto } from "../../../types/news";
import { getFeaturedNews } from "../../../api/transport/newsTransport";
import { TeamContext } from "../../../types/common";
import { getStaticUrl, getUrlByContext } from "../../../utils";
import { Loader } from "../../../components/Loader";
import { FeaturedCard } from "./FeaturedCard";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { CarouselRef } from "antd/es/carousel";

const getFullUrl = (url: string) => {
    return url.includes('http') ? url : `${window.location.origin}${url}`;
}

interface FeaturedNewsWidgetProps {
    teamContext?: TeamContext;
}

export const FeaturedNewsWidget: FC<FeaturedNewsWidgetProps> = ({
    teamContext = TeamContext.RODINA,
}) => {
    const [news, setNews] = useState<FeatureNewsDto[]>([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        getFeaturedNews(teamContext).then((data) => {
            setNews(data);
        }).finally(() => {
            setLoading(false);
        });
    }, [teamContext]);

    const carouselRef = useRef<CarouselRef>(null);

    if (loading) {
        return <Loader />;
    }

    if (!news.length) {
        return null;
    }

    return (
        <div className="group relative opacity-90 hover:opacity-100 max-w-full">
            <Carousel
                ref={carouselRef}
                autoplay={{ dotDuration: true }}
                //arrows
                className="rounded-xl sm:rounded-none overflow-hidden shadow-sm"
            >
                {news.map((newsItem) => {
                    const newsUrl = getUrlByContext(`/${newsItem.entityType}/${newsItem.link}/`, teamContext);
                    return (
                        <FeaturedCard
                            key={newsItem.id}
                            url={getFullUrl(newsUrl)}
                            mediaUrl={getStaticUrl(newsItem.mediaUrl)}
                            title={newsItem.title}
                            description={newsItem.description}
                        />
                    );
                })}
            </Carousel>
            <div
                onClick={() => carouselRef.current?.prev()}
                className="absolute left-1 sm:left-5 bottom-1/2 top-1/2 flex items-center sm:text-xl"
            >
                <div className="cursor-pointer group-hover:transition-all active:bg-slate-200 active:scale-95 hover:bg-sky-100 w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-sky-50 flex items-center justify-center">
                    <LeftOutlined />
                </div>
            </div>
            <div
                onClick={() => carouselRef.current?.next()}
                className="absolute right-1 sm:right-5 bottom-1/2 top-1/2 flex items-center sm:text-xl"
            >
                <div className="cursor-pointer group-hover:transition-all active:bg-slate-200 active:scale-95 hover:bg-sky-100 w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-sky-50 flex items-center justify-center">
                    <RightOutlined />
                </div>
            </div>
        </div>
    );
};